module.exports = __webpack_public_path__ + "static/media/sprite-icon.dd252dd5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprite-icon.svg
// module id = 141
// module chunks = 2